export const FEATURES = {
  AI_FEATURES: true,
  TEAM_COLLABORATION: true,
  WORKFLOW_AUTOMATION: false,
  TESTIMONIALS: true,
  CTA_BANNER: true,
  BLOG: false,
  PRICING: true,
} as const;

export type FeatureFlag = keyof typeof FEATURES;
